import { takeLatest, put, call } from "redux-saga/effects";
import { handleApiError } from "@utils/errorHandler";

import {
  loadAllRelatedContact,
  loadSingleRelatedContact,
} from "./RelatedContactList.slice";

import {
  loadAllRelatedContactAPI,
  loadSingleRelatedContactAPI,
} from "./RelatedContactList.api";

export const LOAD_ALL_RELATED_CONTACT = {
  LOADING: "Load all related contact loading",
  SUCCESS: "Load all related contact success",
  ERROR: "Load all related contact error",
};

export const LOAD_SINGLE_RELATED_CONTACT = {
  LOADING: "Load single related contact loading",
  SUCCESS: "Load single related contact success",
  ERROR: "Load single related contact error",
};

function* loadAllRelatedContactWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadAllRelatedContactAPI, payload);
    yield put(loadAllRelatedContact(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_ALL_RELATED_CONTACT.ERROR, error });
  }
}

function* loadSingleRelatedContactSagaWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadSingleRelatedContactAPI, payload);
    yield put(loadSingleRelatedContact(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_SINGLE_RELATED_CONTACT.ERROR, error });
  }
}

export function* loadAllRelatedContactSaga() {
  yield takeLatest(
    LOAD_ALL_RELATED_CONTACT.LOADING,
    loadAllRelatedContactWorker
  );
}

export function* loadSingleRelatedContactSaga() {
  yield takeLatest(
    LOAD_SINGLE_RELATED_CONTACT.LOADING,
    loadSingleRelatedContactSagaWorker
  );
}
